export interface TeamLeagueInfo {
	uuid: string;
	seasonUuid: string;
	logo: Logo;
	title: string;
	countryId: number;
	localizationId: number;
	organizationUuid: string;
	organizationTitle: string;
	facebook: string;
	twitter: string;
	instagram: string;
	snapchat: string;
	youtube: string;
	tiktok: string;
	dateStart: Date | null;
	dateEnd: Date | null;
	registrationDateOpen: Date | null;
	registrationDateClose: Date | null;
	maxTeamsCount: number;
	registeredTeamsCount: number;
	currencyId: number;
	useScheduleGroups: boolean;
	useOnlineRegistration: boolean;
	isSeasonActive: boolean;
	isPartOfTeamLeague: boolean | null;
	ratingOption: 'RATING_DUPR' | 'RATING_WPR' | 'RATING_UNDEFINED';
	timezoneId: number;
	autoApproveTransfers: ApproveTransfers;
	hideAllRegistrationInfo: boolean;
	utcOffset?: number;
	tieBreakerMatchTitle: string;
	tieBrekaerMatchPluralTitle: string;
	districtSingularTitle: string;
	districtPluralTitle: string;
	matchupSingularTitle: string;
	matchupPluralTitle: string;
}

export enum ApproveTransfers {
	UNDEFINED = 'TRANSFER_APPROVAL_UNDEFINED',
	AUTOMATIC = 'TRANSFER_APPROVAL_AUTOMATIC',
	TRANSFER_APPROVAL_REQUIRES_COMMISSIONER = 'TRANSFER_APPROVAL_REQUIRES_COMMISSIONER',
	TRANSFER_APPROVAL_ONLY_COMMISSIONER_CAN_INITIATE = 'TRANSFER_APPROVAL_ONLY_COMMISSIONER_CAN_INITIATE'
}

export interface Logo {
	uuid: string;
	moduleFor: string;
	moduleUuid: string;
	url: string;
	isPrimary: boolean;
	dateCreated?: Date | null;
	dateUpdated: Date | null;
	dateDisabled: Date | null;
	createdByUuid: string;
	updatedByUuid: string | null;
}
